// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1tWuB","content":"ManualTimeModal_content__3oQ_l"};